export default function getViewportWidth() {
	return window.innerWidth;
}
